import buyEthAd from './buyEthAd';
import staticAd from './staticAd';
import mewConnectAd from './mewConnectAd';

export default {
  buyEthAd,
  staticAd,
  mewConnectAd
};
